import styled, { css } from 'styled-components';

import Colours from '/shared/styled/Colours';

interface Props {
  $expanded?: boolean;
}

function expandedStyle({ $expanded = false }: Props) {
  if ($expanded) {
    return css`
      .accord-items {
        grid-template-rows: minmax(0, 1fr);
      }

      .accord-heading {
        .icon {
          img {
            transform: rotateX(-180deg);
            transform-origin: 50% 50%;
          }
        }
      }
    `;
  }
}
export default styled.div<Props>`
  background-color: ${Colours.white};
  transition: background-color 0.5s ease;
  width: 100%;
  margin-bottom: 2rem;

  .accord-heading {
    padding: 1rem;
    display: flex;
    justify-content: space-between;
    background-color: ${Colours.whiteDark1};
    border: 1px solid ${Colours.greyLight4};
    border-radius: 0.25rem;
    cursor: pointer;

    &:hover {
      border-color: ${Colours.green};
      background-color: ${Colours.greenLight8};
    }

    .text {
    }

    .icon {
      padding: 1rem;

      img {
        transition: all 0.5s ease;
      }
    }
  }

  .accord-items {
    display: grid;
    grid-template-rows: minmax(0, 0fr);
    overflow: hidden;
    position: relative;
    transition: grid-template-rows 0.35s ease;
    background-color: ${Colours.whiteDark1};

    > div {
      overflow: hidden;
      padding: 2rem 1.5rem;
      min-height: 0;
    }
  }
  ${expandedStyle}
`;
